/**
 * Константы для вкладки «Ошибки Content API» (4-я вкладка Журнала).
 *
 * Источник данных — admin-эндпоинты `/journal/content-api-errors`:
 * фильтрация по периоду / статусам / пути + пагинация limit/offset.
 */

/** Имена полей фильтр-формы (используются как query-параметры эндпоинта). */
export const FieldNames = {
  DATE_FROM: 'from',
  DATE_TO: 'to',
  STATUS_CODES: 'statusCodes',
  PATH: 'path',
};

/**
 * Маппинг полей формы → ключи локализации лейблов.
 * Источник истины для подписей filter form'ы.
 */
export const ContentApiErrorsFieldLabelKeys = {
  [FieldNames.DATE_FROM]: 'JOURNAL_labels_from',
  [FieldNames.DATE_TO]: 'JOURNAL_labels_to',
  [FieldNames.STATUS_CODES]: 'JOURNAL_CONTENT_API_ERRORS_labels_status',
  [FieldNames.PATH]: 'JOURNAL_CONTENT_API_ERRORS_labels_path',
};

/**
 * Доступные пресеты статусов в multi-select.
 * Значения совпадают с тем, что принимает backend (CSV токенов):
 * `4xx`/`5xx` — класс, остальное — конкретный HTTP-код.
 */
export const STATUS_CODE_OPTION_VALUES = {
  CLASS_4XX: '4xx',
  CLASS_5XX: '5xx',
  CODE_400: '400',
  CODE_401: '401',
  CODE_403: '403',
  CODE_404: '404',
  CODE_422: '422',
  CODE_500: '500',
  CODE_502: '502',
  CODE_503: '503',
};

/** Начальные значения фильтр-формы (все undefined → берём дефолты сервера). */
export const INITIAL_VALUES = {
  [FieldNames.DATE_FROM]: undefined,
  [FieldNames.DATE_TO]: undefined,
  [FieldNames.STATUS_CODES]: undefined,
  [FieldNames.PATH]: undefined,
};

/**
 * Колонки таблицы списка ошибок. Порядок соответствует UI/UX spec'у.
 * Используется shared <Table> компонентом для пометки sortable-колонок.
 */
export const ERROR_COLUMN_KEYS = [
  'createdAt',
  'statusCode',
  'method',
  'path',
  'errorMessage',
];

/**
 * Максимальная длина errorMessage в ячейке таблицы (truncate с ellipsis).
 * Backend дополнительно truncate'ит до 200 — наш список ещё короче для UI.
 */
export const ERROR_MESSAGE_TRUNCATE = 80;

/** Лимит записей на одну страницу (совпадает с дефолтом backend). */
export const CONTENT_API_ERRORS_LIMIT = 30;

/** Минимум для расчёта количества страниц в селекторе. */
export const CONTENT_API_ERRORS_MIN_COUNT = 0;

/** Минимальный номер страницы пагинации (1-based). */
export const CONTENT_API_ERRORS_MIN_PAGE = 1;

/** Граница 4xx-кодов (включительно сверху). */
export const STATUS_CLIENT_ERROR_MAX = 499;

/** Граница 4xx-кодов (включительно снизу). */
export const STATUS_CLIENT_ERROR_MIN = 400;

/** Граница 5xx-кодов (включительно снизу). */
export const STATUS_SERVER_ERROR_MIN = 500;
